import React, { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BalanceCheck = () => {
  const [code, setCode] = useState('');
  const [result, setResult] = useState(null);

  const check = async (e) => {
    e.preventDefault();
    try { setResult((await axios.get(`${API}/gift-cards/check/${encodeURIComponent(code.trim())}`)).data); }
    catch { setResult({ error: true }); }
  };

  return (
    <form onSubmit={check} data-testid="balance-check-form">
      <p className="text-[11px] tracking-[0.2em] text-[#1E1B18]/55 mb-2">HAVE A GIFT CARD? CHECK ITS BALANCE</p>
      <div className="flex gap-2">
        <input data-testid="balance-check-input" required value={code} onChange={(e) => setCode(e.target.value)} placeholder="AL-XXXX-XXXX-XXXX"
          className="flex-1 min-w-0 bg-[#FBF7F0] border border-[#1E1B18]/15 focus:border-[#8B7FB8] outline-none rounded-full px-4 py-2.5 text-[13px] uppercase" />
        <button data-testid="balance-check-btn" className="border border-[#1E1B18]/25 hover:border-[#1E1B18]/60 rounded-full px-5 text-[12px] font-medium transition-colors">Check</button>
      </div>
      {result && (
        <p data-testid="balance-check-result" className="mt-3 text-[13px] text-[#1E1B18]/75">
          {result.error ? 'Gift card not found.' : `Balance: $${result.balance} · ${result.status}`}
        </p>
      )}
    </form>
  );
};
